import FooterFrame from '../Components/Images/ff.png'
import Logo from '../Components/Images/Logo base.svg'
import arrow from '../Components/Images/arrow-right.svg'
import { useLocation } from 'react-router-dom'

const Footer = () => {

    const location = useLocation()

    return (
        <div className='relative w-full bg-[#271D2E] pt-24'
            style={{
                backgroundImage: `url(${FooterFrame})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundColor: '#271D2E'
            }}
        >
            <div className='w-full text-white'>
                <div className='sp:w-[400px] text-center px-3 flex flex-col items-center mx-auto'>
                    {location.pathname === '/' ? (
                        <p className='sp:text-[35px] text-[30px] leading-tight text-wrap font-bold'>Ready to level up your money game?</p>
                    ) : (
                        <p className='sp:text-[35px] text-[30px] leading-tight text-wrap font-bold'>Still not sure if <br /> Reccur fits?</p>
                    )}
                    {location.pathname === '/' ? (
                        <p className='text-[16px] mt-4 leading-7 text-[#D2D0D6]'>5 minutes to setup. No hidden fees. No crypto knowledge needed.</p>
                    ) : (
                        <p className='text-[16px] mt-4 leading-7 text-[#D2D0D6]'>If your money starts or ends outside your home country, and the banks make it slow or expensive - Reccur is built for you.</p>
                    )}
                    <a className='mt-10' href="/signup">
                        <button className='bg-[#531CB3] mx-auto text-base text-white flex gap-3 items-center justify-center py-3 px-5 rounded-lg'>
                            Get Your US Account
                            <img src={arrow} alt="" />
                        </button>
                    </a>
                </div>
                <hr className='opacity-20 mt-20 sh:mx-10 mx-6' />
                <div className='sh:px-20 px-6 pt-20 mk:grid flex flex-col grid-cols-3 mk:gap-[120px] gap-10'>
                    <div className='text-[#B5B3BA] font-normal'>
                        <img src={Logo} alt="" />
                        <p className='mt-3'>Reccur is making it easier to move money globally. Receive payment from the US or Europe like a local and send money to 10+ countries like a local.
                        </p>
                        <p className='mt-3'>© Reccur Inc, 2025.</p>
                    </div>
                    <div className='col-span-2 grid mh:grid-cols-4 sp:grid-cols-3 grid-cols-2 justify-between mh:gap-0 sp:gap-5 gap-20'>
                        <div className='flex flex-col gap-5'>
                            <p className='text-[14.5px] uppercase font-semibold'>Lifestyle</p>
                            <p className='mh:text-[18px] text-[#E6E4EB] font-normal'>Crypto fam</p>
                            <p className='mh:text-[18px] text-[#E6E4EB] font-normal'>Digital hustlers</p>
                            <p className='mh:text-[18px] text-[#E6E4EB] font-normal'>Global users</p>
                            <p className='mh:text-[18px] text-[#E6E4EB] font-normal'>Power users</p>
                        </div>
                        <div className='flex flex-col gap-5'>
                            <p className='text-[14.5px] uppercase font-semibold'>General</p>
                            <a href='/' className='mh:text-[18px] text-[#E6E4EB] font-normal'>Home</a>
                            <a href='/how_it_works' className='mh:text-[18px] text-[#E6E4EB] font-normal'>How it works</a>
                            <a href='/about' className='mh:text-[18px] text-[#E6E4EB] font-normal'>About us</a>
                            <a href='/use_cases' className='mh:text-[18px] text-[#E6E4EB] font-normal'>Use cases</a>
                        </div>
                        <div className='flex flex-col gap-5'>
                            <p className='text-[14.5px] uppercase font-semibold'>Legal</p>
                            <p className='mh:text-[18px] text-[#E6E4EB] font-normal'>Privacy policy</p>
                            <p className='mh:text-[18px] text-[#E6E4EB] font-normal'>Terms of service</p>
                            <p className='mh:text-[18px] text-[#E6E4EB] font-normal'>Support</p>
                            <p className='mh:text-[18px] text-[#E6E4EB] font-normal'>Contact</p>
                        </div>
                        <div className='flex flex-col gap-5'>
                            <p className='text-[14.5px] uppercase font-semibold'>Social</p>
                            <a href='https://www.linkedin.com/company/reccur/' className='mh:text-[18px] text-[#E6E4EB] font-normal'>LinkedIn</a>
                            <a href='https://x.com/tryreccur?s=21' className='mh:text-[18px] text-[#E6E4EB] font-normal'>X</a>
                        </div>
                    </div>
                </div>
                <hr className='opacity-20 mt-20 sh:mx-10 mx-6' />
                {location.pathname === '/' ? (
                    <p className='sh:p-20 p-6 text-[#F3F0F7] font-normal'>Reccur is a financial technology company and we’re not a bank. Reccur moves money across countries through stablecoints (USDC) for quick and near-instant settlements</p>
                ) : (
                    <p className='sh:p-20 p-6 text-[#F3F0F7] font-normal'>This is some important spill about how we are delivering Reccur. This is normally included on websites that have a little more explaining to do or provide additional context for the services that they provide. </p>
                )}
                <p className='xl:text-[145px] 2xl:text-[300px mk:text-[105px] md:text-[90px] sh:text-[70px] sa:text-[60px] sk:text-[50px] sr:text-[40px] text-[33px] text-center bg-gradient-to-b from-white/30 to-[#271D2E] bg-clip-text py-12 text-transparent font-bold'>try reccur today!</p>
            </div>
        </div>
    )
}

export default Footer